'use client'
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-literals */
import React, { useContext, useEffect, useRef, useMemo, memo } from 'react'
import { useSearchParams, usePathname } from 'next/navigation'
import cloneDeep from 'lodash/cloneDeep'
import Error from '../Error'
import { LayoutComponent, SectionHeading } from '../../index'
import {
  PRODUCT_COLLECTION,
  CATEGORY_COLLECTION,
  BRAND_COLLECTION,
  HOME,
  PROMOTIONS,
  SELLER,
  SELLER_COLLECTION,
} from '../../../utils/constDictionary'
import encodedURIComponentQueryStringConverter from '../../../utils/encodedURIComponentQueryString'
import { SectionWrapper, StyledMain } from './styles'
import { CartContext } from '../../../providers/CartProvider'
import checkLayoutExist from '../../../utils/checkLayoutExist'
import { clearData, getData } from '../../../lib'
import ErrorBoundary from '../../../lib/ErrorBoundary'
import LayoutSkelaton from '../LayoutSkelatonLoader'
import { useSelector } from 'react-redux'

const themesWithSideMenu = ['Zopnow', 'theme-wsi']
const layoutsWithDivider = [
  PRODUCT_COLLECTION,
  CATEGORY_COLLECTION,
  BRAND_COLLECTION,
  PROMOTIONS,
  SELLER,
  SELLER_COLLECTION,
]

const collectionHasData = (collectionData) => {
  if (
    (Array.isArray(collectionData) && collectionData.length > 0) ||
    collectionData?.count > 0
  ) {
    return true
  }
  return false
}

const MainUI = memo(function MainUI({
  layouts,
  pageName,
  websiteTheme,
  showFilter,
  entity,
  checkoutProps,
  baseURL,
  loading,
  productLoading,
}) {
  const { cart } = useContext(CartContext)
  const isLoggedin = useSelector((state) => state.auth.isLoggedin)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const hasSideMenu = themesWithSideMenu.includes(websiteTheme)
  const getzTheme = websiteTheme === 'Getz'
  const zopstore = websiteTheme === 'ZopStore'
  const moonshotTheme = websiteTheme === 'Moonshot'
  const quickTheme = websiteTheme === 'Quick' || websiteTheme === 'Bazar'
  const medicoreTheme = websiteTheme === 'MediCore'
  const isLogInOrSignUp = pathname === '/login' || pathname === '/signup'
  const categoryPage = pathname.includes('/category/')
  const subCategoryPage =
    searchParams?.hasOwnProperty('filter') || searchParams?.filter
  const layoutsData = useMemo(() => cloneDeep(layouts), [layouts])
  const recentlyBoughtLayoutExist = useMemo(
    () =>
      layoutsData?.filter((lyout) => lyout.name === 'RecentlyBoughtProducts'),
    [layoutsData]
  )
  const primaryCategory = layoutsData?.find(
    (layout) => layout.name === 'ProductCollection'
  )?.value?.collection?.product?.[0]?.primaryCategory?.name

  let pastItemsExist = false
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      localStorage &&
      Object.prototype.hasOwnProperty.call(localStorage, 'pastItems')
    ) {
      pastItemsExist =
        recentlyBoughtLayoutExist &&
        isLoggedin &&
        JSON.parse(getData('pastItems')).length > 0
    }
    if (getzTheme && pageName === 'HOME') {
      layoutsData.push({
        data: { layoutType: 'SCROLLER' },
        name: 'AllManufacturers',
        value: {},
      })
      layoutsData.splice(2, 0, {
        data: { layoutType: 'SCROLLER' },
        name: 'Promotions',
        value: {},
      })
    }
    if (medicoreTheme && pageName === 'HOME') {
      layoutsData.unshift({
        data: { layoutType: 'SCROLLER' },
        name: 'DynamicCollection',
        value: {},
      })
    }
  }, [
    recentlyBoughtLayoutExist,
    isLoggedin,
    getzTheme,
    pageName,
    layoutsData,
    medicoreTheme,
  ])

  useEffect(() => {
    const storedFilters = localStorage.getItem('filters')
    if (
      storedFilters !== null &&
      JSON.parse(storedFilters) &&
      pathname !== '/products' &&
      websiteTheme === 'Getz'
    ) {
      clearData('filters')
    }
  }, [pathname, websiteTheme])

  useEffect(() => {
    if (!quickTheme) return undefined
    document.body.style.minHeight = '100vh'
    document.body.style.overflowX = 'hidden'
    return () => {
      document.body.style.minHeight = ''
      document.body.style.overflowX = ''
    }
  }, [quickTheme])
  // const excludeRoutes = ['/pages/[page]']

  const targetRef = useRef(null)
  return (
    <>
      {loading ? (
        <div style={{ height: '70vh' }}>
          <LayoutSkelaton layoutName="ContentBlock" />
        </div>
      ) : (
        <ErrorBoundary>
          <StyledMain
            websiteTheme={websiteTheme}
            hasSideMenu={hasSideMenu}
            getzTheme={getzTheme}
            zopstore={zopstore}
            moonshotTheme={moonshotTheme}
            quickTheme={quickTheme}
            pageName={pageName}
            cartProductsCount={cart?.items?.length}
            isLogInOrSignUp={isLogInOrSignUp}
            categoryPage={categoryPage}
            subCategoryPage={subCategoryPage}
          >
            {!Array.isArray(layoutsData) ? (
              <Error data={{ code: '404', message: 'Page not found' }} />
            ) : (
              layoutsData?.map((layout, index) => {
                const { name, value, data } = layout
                const isIntersecting = true
                const showLayout = checkLayoutExist({
                  name,
                  value,
                  isLoggedin,
                  pageName,
                })
                const categoryCollection = name === 'CategoryCollection'
                const productCollection = name === 'ProductCollection'
                const imageSlideShow = name === 'ImageSlideShow'
                return (
                  showLayout && (
                    <SectionWrapper
                      className="has-content"
                      moonshotTheme={moonshotTheme}
                      quickTheme={quickTheme}
                      categoryPage={categoryPage}
                      subCategoryPage={subCategoryPage}
                      categoryCollection={categoryCollection}
                      productCollection={productCollection}
                      imageSlideShow={imageSlideShow}
                      key={`layout-${name}-${index}`}
                      home={pageName === 'HOME' || pageName === 'SELLER'}
                      isMarquee={name === 'Marquee' && index === 0}
                      showSection={
                        layout.name === 'RecentlyBoughtProducts'
                          ? pastItemsExist
                          : value?.collection?.count ?? true
                      }
                      ref={targetRef}
                      childLength={targetRef?.current?.children?.length}
                      websiteTheme={websiteTheme}
                    >
                      {layout &&
                        (pageName === HOME || pageName === SELLER) &&
                        layoutsWithDivider.includes(name) &&
                        collectionHasData(value.collection) &&
                        isIntersecting && (
                          <SectionHeading
                            websiteTheme={websiteTheme}
                            title={value.title}
                            loadMoreType={data?.loadMoreType}
                            layout={layout}
                            uri={encodedURIComponentQueryStringConverter(
                              '/products',
                              data
                            )}
                            name={name}
                          />
                        )}
                      {(isIntersecting ||
                        layout.name === 'RecentlyBoughtProducts') && (
                        <LayoutComponent
                          websiteTheme={websiteTheme}
                          layout={layout}
                          productCollectionColCount={4}
                          name={pageName}
                          showFilter={showFilter}
                          entity={entity}
                          checkoutProps={checkoutProps}
                          title={value?.title}
                          layoutIndex={index}
                          baseURL={baseURL}
                          primaryCategory={primaryCategory}
                          productLoading={productLoading} 
                        />
                      )}
                    </SectionWrapper>
                  )
                )
              })
            )}
          </StyledMain>
        </ErrorBoundary>
      )}
    </>
  )
})
export default MainUI
